import axios from 'axios';
import * as config from '../config';

export const SETCLIENTS = 'users/SETCLIENTS';
export const SETISLOADINGINCLIENTS = 'users/SETISLOADINGINCLIENTS';

export const getClients = (onSuccess = () => {}, onError = () => {}) => {
  return (dispatch) => {
    dispatch({ type: SETISLOADINGINCLIENTS, isLoadingClients: true });
    axios(`${config.endpoints.base_url}v1/godlike/clients`)
      .then((resp) => {
        const clients = Array.isArray(resp.data.data) ? resp.data.data : [];
        dispatch({ type: SETISLOADINGINCLIENTS, isLoadingClients: false });
        dispatch({ type: SETCLIENTS, clients });
        return onSuccess({ data: clients });
      })
      .catch((err) => {
        dispatch({ type: SETISLOADINGINCLIENTS, isLoadingClients: false });
        onError(err);
      });
  };
};

export const updateClientNetworks = (authUserId, networks) => {
  return axios.put(
    `${config.endpoints.base_url}v1/godlike/clients/${authUserId}/networks`,
    { networks }
  );
};

export const createClient = (clientId, name, networks, serviceAccountsEnabled = false) => {
  return axios.post(`${config.endpoints.base_url}v1/godlike/clients`, {
    clientId,
    serviceAccountsEnabled,
    ...(name ? { name } : {}),
    ...(serviceAccountsEnabled && networks && networks.length > 0 ? { networks } : {}),
  });
};

export const fetchClientSecret = (clientId) => {
  return axios(`${config.endpoints.base_url}v1/godlike/clients/${clientId}/secret`)
    .then((resp) => resp.data.data?.secret ?? null);
};

// Fetches all networks from the GodLike endpoint — no user-network filter, sorted by name
export const fetchAllNetworks = () => {
  return axios(`${config.endpoints.base_url}v1/godlike/networks`)
    .then((resp) => resp.data.data ?? []);
};
